<template>
  <div class="container" v-wechat-title="$route.meta.title">
    <!-- 营业报表 -->
    <div class="onePart">
      <div
        v-if="changeIndex == 0"
        v-bind:class="{ day:changeIndex== 0,'date-bar':1}"
      >{{showDate(beginDay)}}</div>
      <div v-if="changeIndex == 2" class="date-bar">
        {{showDate(beginDay,'y')}}
        <span @click="selectDate('sub')">&lt;&lt;</span>
        {{showDate(beginDay,'m')}}
        <span @click="selectDate('add')">&gt;&gt;</span>
      </div>
      <!-- <div hidden v-if="changeIndex == 0" style="text-align: center;font-size: 0.4rem;" class="titlePart">
    <van-cell title="选择单个日期" :value="getDate" @click="show = true" />
    <van-calendar v-model="show" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" />
  </div>

  <div hidden v-if="changeIndex == 2" style="text-align: center;font-size: 0.4rem;" class="titlePart">
    <van-cell title="选择月份区间" :value="getDate" @click="show = true" />
    <van-calendar v-model="show" :min-date="minDate" :max-date="maxDate" type="range" @confirm="onConfirm" />
      </div>-->
      <div class="topChange disp-just-aro-ali-cen">
        <div @click="changeType" :index="0" :class="[changeIndex==0?'div1':'div2']">今日</div>

        <div @click="changeType" :index="2" :class="[changeIndex==2?'div1':'div2']">月报</div>
      </div>
      <div class="wrap disp-ali-cen">
        <div class="info info1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">接待总数（台次）<p @click="checkQues('接待总数_'+(changeIndex+1))" class="ques"></p></div>
          <div>{{getOneDimension("接车台次统计",0)}}</div>
          <div>
            <span v-if="changeIndex == 0">昨日接待数：{{getOneDimension("昨日接车台次统计",0)}}</span>
            <span v-else>&nbsp;</span>
          </div>
        </div>
        <div class="info info1 disp-just-aro-ali-cen-fldir-col">
          <div class="div-relative">预约到店（台次）<p @click="checkQues('预约到店_'+(changeIndex+1))" class="ques"></p></div>
          <div>{{getOneDimension("预约到店台次统计",0)}}</div>
          <div>
            <span v-if="changeIndex == 0">昨日预约到店：{{getOneDimension("昨日预约到店台次",0)}}</span>
            <span v-else>&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 施工工作量分配 -->
    <div v-if="Admin" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">施工工作量分配 <p @click="checkQues('施工工作量分配_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 施工类型 -->
    <div v-if="Admin" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">施工类型 <p @click="checkQues('施工类型_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieTwo" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 施工进度 -->
    <div v-if="Admin" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">施工进度 <p @click="checkQues('施工进度_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="pieThree" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 车型分布 -->
    <div v-if="Admin" class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">车型分布（台）<p @click="checkQues('车型分布_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="barOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <div class="divPlaceholder">&nbsp;</div>
    <!-- loading的显示隐藏 -->
    <Loading v-show="loadShow"></Loading>
    <popupWin v-if="popupIsShow" :popupShow="isPopupShow" :keyWords="keyWord" @childRe="childReturn"></popupWin>
    <!-- <van-popup
      v-model="popupShow"
      closeable
      round
      position="bottom"
      :style="{ height: '30%' }"
    >
      <p class="popup-p popup-p1">计算方式</p>
      <p class="popup-p popup-p2">{{popupTitle}}</p>
      <p class="popup-p popup-p3">{{popupContent}}</p>
    </van-popup> -->
  </div>
</template>
<script>
import Vue from "vue";
import util from "../../static/js/util";
import { Toast } from "vant";
Vue.use(Toast);
import baseUrl from "../../static/js/basedata.js";

export default {
  name: "InfoPage",
  inject:['reload'],
  data() {
    return {
      Admin: true,
      changeIndex: 0,
      beginDay: new Date(),
      endDay: new Date(),
      RptData: {},
      loadShow: false,
      show: false,
      minDate: new Date(),
      maxDate: new Date(2999, 1, 1),
      isPopupShow: false,
      keyWord:'',//带入组件关键字
      popupIsShow:false,
      popupShow:false,//底部弹框是否显示
      keyWords:'',
      popupTitle:'弹框标题',//弹框标题
      popupContent:'弹框内容',//弹框标题
    };
  },
  computed: {
    getDate: function() {
      if (this.changeIndex == 0) {
        return this.formatDate(new Date(this.beginDay));
      } else {
        return `${this.formatDate(new Date(this.beginDay))} - ${this.formatDate(
          new Date(this.endDay)
        )}`;
      }
    }
  },
  methods: {
    checkQues(_key){
      console.log(_key)
      this.isPopupShow = true;
      this.keyWord = _key;
      this.popupIsShow = true;
    },
    childReturn(data){
      console.log('data-----',data)
      this.isPopupShow = data;
      this.popupIsShow = data;
    },
    formatDate(date) {
      // 今日选择
      if (this.changeIndex == 0) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 1) {
        // 周选择
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 2) {
        // 月选择
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      }
    },
    showDate(date, mode) {
      // 今日选择
      mode = mode || "a";
      date = new Date(date);
      if (this.changeIndex == 0) {
        return `${date.getFullYear()}年${date.getMonth() +
          1}月${date.getDate()}日`;
      } else if (this.changeIndex == 1) {
        // 月选择
        return `${date.getFullYear()}年 << ${date.getMonth() + 1}月 >>`;
      } else if (this.changeIndex == 2) {
        // 月选择
        if (mode === "y") {
          return `${date.getFullYear()}年`;
        }
        if (mode === "m") return `${date.getMonth() + 1}月`;
      }
    },
    onConfirm(date) {
      if (this.changeIndex == 0) {
        this.beginDay = date.format("yyyy-MM-dd");
        this.endDay = date.format("yyyy-MM-dd");
      } else {
        const [start, end] = date;
        this.beginDay = start.format("yyyy-MM-dd");
        this.endDay = end.format("yyyy-MM-dd");
      }
      this.loadData();
    },
    changeType(e) {
      var index = e.target.getAttribute("index");
      this.changeIndex = Number(index);
      var date = this.$dateUtil.today();
      switch (this.changeIndex) {
        case 0:
          date = this.$dateUtil.today();
          break;
        case 1:
          date = this.$dateUtil.thisWeek();
          break;
        case 2:
          date = this.$dateUtil.thisMonth();
          break;
      }
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
    },
    selectDate(mode) {
      if (this.changeIndex == 2) {
        if (mode === "add") {
          var date = new Date(this.beginDay);
          date.setDate(1);
          date.setMonth(date.getMonth() + 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setMonth(date.getMonth() + 1);
          date.setDate(0);
          this.endDay = date.format("yyyy-MM-dd");
        } else if (mode === "sub") {
          var date = new Date(this.beginDay);
          date.setDate(1);
          date.setMonth(date.getMonth() - 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setMonth(date.getMonth() + 1);
          date.setDate(0);
          this.endDay = date.format("yyyy-MM-dd");
        }
        this.loadData();
      }
    },
    backLast() {
      this.$router.go(-1); //返回上一层
    },
    loadData() {
      var that = this;
      this.show = false;
      that.loadShow = true;
      var query = {
        ReportType: this.$util.AppReportType.业务报表,
        Begin: this.beginDay,
        End: this.endDay
      };
      this.$api.get(
        "/AppReport",
        query,
        function(res) {
          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        },
        function(err) {
          that.loadShow = false;
        }
      );
    },
    getOneDimension(subTypeName, def) {
      return this.$util.getOneDimension(this.RptData.Items, subTypeName, def);
    },
    getTwoDimension(subTypeName, defX, defY) {
      return this.$util.getTwoDimension(
        this.RptData.Items,
        subTypeName,
        defX,
        defY
      );
    },
    getTwoDimensionBar(subTypeName, defY, defValue, valueColumn) {
      return this.$util.getTwoDimensionBar(
        this.RptData.Items,
        subTypeName,
        defY,
        defValue,
        valueColumn
      );
    },
    drawPie() {
      var pieOneData = this.getTwoDimension("施工工作量", "其他", "0");
      this.$echarts
        .init(document.getElementById("pieOne"))
        .setOption(this.$util.PieOption(pieOneData, "台"));

      var pieTwoData = this.getTwoDimension("施工类型", "其他", "0");
      this.$echarts
        .init(document.getElementById("pieTwo"))
        .setOption(this.$util.PieOption(pieTwoData, "台"));

      var pieThreeData = this.getTwoDimension("施工进度", "其他", "0");
      this.$echarts
        .init(document.getElementById("pieThree"))
        .setOption(this.$util.PieOption(pieThreeData, "台"));

      var barOneData = this.getTwoDimensionBar("客户车辆类型分布", "其他", "0");
      this.$echarts
        .init(document.getElementById("barOne"))
        .setOption(this.$util.BarOption(barOneData, "车型"));
    }
  },
  mounted() {
    this.Admin = this.$api.IsAdmin();
    var date = this.$dateUtil.today();
    this.beginDay = date.Begin;
    this.endDay = date.End;
    this.loadData();

    phoneDevice.setTitle(this.$route.meta.title || "");
  }
};
</script>

<style>
@import url("../../static/css/common.css");
.topChange {
  width: 100%;
  margin-bottom: 0.53rem;
}
.van-cell {
  border: 0.04rem solid transparent;
}
.topChange .div1 {
  width: auto;
  font-size: 0.34rem;
  color: #1c1c1c;
  border-bottom: 0.05rem solid #1699e5;
}
.topChange .div2 {
  width: auto;
  font-size: 0.34rem;
  color: #999999;
  border-bottom: 0.05rem solid transparent;
}
.container {
  width: 10rem;
  min-height: 100vh;
  background: #f2f2f2;
  /* background: pink; */
  padding: 0 0.34rem 0.4rem;
  box-sizing: border-box;
  border-top: 0.01rem solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/yingyebaobiao.vue